<template>
	<span>
	<app-button
		@click="show = true"
		v-bind="this.$props"
	>
		<slot></slot>
	</app-button>
	<app-dialog
		v-model="show"
		:max-width="maxWidth"
		:title="title"
	>
		<app-dialog-body v-if="!custom" v-html="description"></app-dialog-body>
		<slot v-else name="body"></slot>
		<app-dialog-footer>
			<app-button
				:color="color"
				flat="flat"
				@click="onConfirm"
			>
				{{labelConfirm}}
			</app-button>
			<app-button
				flat="flat"
				@click="show = false"
			>
				{{labelCancel}}
			</app-button>
		</app-dialog-footer>
	</app-dialog>
	</span>
</template>

<script>
import AppButton from './AppButton.vue'

export default {
	extends: AppButton,
	props: {
		labelConfirm: {
			type: String,
			default: 'Confirm',
		},
		labelCancel: {
			type: String,
			default: 'Cancel',
		},
		description: {
			type: String,
			default: 'Are you sure?',
		},
		custom: {
			type: Boolean,
			default: false,
		},
		maxWidth: {
			type: String,
			default: '320',
		},
		title: {
			type: String,
		},
	},
	watch: {
		show() {
			if (!this.show) {
				this.$emit('close')
			}
		},
	},
	methods: {
		onConfirm(event) {
			this.show = false
			if (this.to) {
				this.$router.push(this.to)
			} else {
				this.$emit('click', event)
			}
		},
	},
	data() {
		return {
			show: false,
		}
	},
}
</script>
